<template>
  <div>
    <!-- Modal -->
    <b-modal
      id="cancel-bets-modal"
      title=""
      size="lg"
      centered
      body-class="modal-body-scrollable"
      @shown="handleFetchBets"
    >
      <template #modal-header>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <feather-icon
              size="20"
              icon="AlertTriangleIcon"
              class="text-danger mr-1"
            />
            <h4 class="mb-0 text-danger">Bets to be Cancelled</h4>
          </div>
          <b-button variant="link" class="p-0" @click="closeModal">
            <feather-icon icon="XIcon" size="20" class="text-muted" />
          </b-button>
        </div>
      </template>

      <p class="text-muted small">
        The following {{ bets.length }} bets will be cancelled and refunded:
      </p>

      <b-card
        style="
          background: #dbeafe;
          border: 1px solid #93c5fd;
          border-radius: 6px;
        "
      >
        <b-row class="text-center">
          <b-col cols="4">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ bets.length }} Bets
            </h4>
            <span style="color: #1e40af">will be cancelled</span>
          </b-col>

          <b-col cols="4">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ formatCurrencyBuiltInFunc(totalRefund) }}
            </h4>
            <span style="color: #1e40af">to be refunded</span>
          </b-col>

          <b-col cols="4">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ formatCurrencyBuiltInFunc(totalLiability) }}
            </h4>
            <span style="color: #1e40af">liability released</span>
          </b-col>
        </b-row>
      </b-card>

      <b-table
        :items="bets"
        :fields="tableFields"
        responsive
        small
        head-variant="light"
        show-empty
      >
        <template #cell(user)="{ item }">
          <span class="text-nowrap">{{ item.userName }}</span>
        </template>
        <template #cell(profile)="{ item }">
          <b-badge :variant="profileColor(item.profile)" pill>{{
            item.profile || "-"
          }}</b-badge>
        </template>

        <template #cell(runner)="{ item }">
          <span class="text-nowrap"
            >{{ item.legNumber }}. {{ item.legName }}</span
          >
        </template>

        <template #cell(stake)="{ item }">
          {{ formatCurrencyBuiltInFunc(item.stake) }}
        </template>

        <template #cell(liability)="{ item }">
          {{ formatCurrencyBuiltInFunc(item.liability) || "-" }}
        </template>

        <template #cell(status)="{ item }">
          <b-badge :variant="statusVariant(item.status)" pill>{{
            item.status || "-"
          }}</b-badge>
        </template>
      </b-table>

      <template #modal-footer>
        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button variant="secondary" class="mr-1" @click="closeModal"
            >Cancel</b-button
          >
          <b-button
            variant="danger"
            @click="confirmAbandon"
            :loading="loadingAbandon"
            >Confirm Abandon Race</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
} from "bootstrap-vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";

export default {
  components: {
    BButton,
    BModal,
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
  },
  data() {
    return {
      bets: [],
      page: 1,
    };
  },
  computed: {
    tableFields() {
      return [
        { key: "user", label: "User" },
        { key: "profile", label: "Profile" },
        { key: "runner", label: "Runner" },
        { key: "betType", label: "Bet Type" },
        { key: "stake", label: "Stake" },
        { key: "liability", label: "Liability" },
        { key: "status", label: "Status" },
      ];
    },
    totalRefund() {
      return this.bets.reduce((s, b) => s + b.stake, 0);
    },
    totalLiability() {
      return this.bets.reduce((s, b) => s + b.liability, 0);
    },
    ...mapState("trading/racing", ["loadingAbandon"]),
  },
  methods: {
    ...mapActions("trading/racing", {
      abandonRace: "updateRaceDetail",
      getBetsOfRace: "getBetsOfRace",
    }),
    openModal() {
      this.$bvModal.show("cancel-bets-modal");
    },
    closeModal() {
      this.$bvModal.hide("cancel-bets-modal");
    },
    format,
    formatCurrencyBuiltInFunc,
    profileColor(name) {
      const map = {
        VIP: "dark",
        Standard: "secondary",
        Premium: "purple",
        Regular: "secondary",
        Gold: "warning",
        Silver: "light",
        Bronze: "brown",
      };
      if (name === "Premium") return "info";
      if (name === "Bronze") return "warning";
      if (name === "Silver") return "light";
      return map[name] || "secondary";
    },
    statusVariant(status) {
      switch (status) {
        case "active":
          return "primary";
        default:
          return "secondary";
      }
    },
    async confirmAbandon() {
      const raceId = this.$route.query.raceId;
      if (!raceId) return;
      const result = await this.abandonRace({
        raceId,
        finalStatus: "ABANDONED",
      });
      if (result) {
        this.closeModal();
        this.$emit("onFetchRaces");
      }
    },
    async handleFetchBets() {
      const raceId = this.$route.query.raceId;
      if (!raceId) return;
      const { page } = this;
      const results = await this.getBetsOfRace({
        page,
        raceId,
      });
      this.bets = results;
    },
  },
};
</script>
<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>